import { render } from "./DigPinkCampaignPageV2.vue?vue&type=template&id=c2bdafa6&scoped=true"
import script from "./DigPinkCampaignPageV2.vue?vue&type=script&lang=js"
export * from "./DigPinkCampaignPageV2.vue?vue&type=script&lang=js"

import "./DigPinkCampaignPageV2.vue?vue&type=style&index=0&id=c2bdafa6&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2bdafa6"]])

export default __exports__